import CookieStorage from './CookieStorage';
import cookie from 'cookie';
import Gateway from '../Gateway';

export default class EnquiriesSent extends CookieStorage {
  constructor() {
    super();
    const valueFromCookie = cookie.parse(Gateway.window.document.cookie)[this.key];
    this.data = valueFromCookie ? [...new Set([...valueFromCookie.split(',')])].map((index) => Number(index)) : this._defaultValue;
  }

  get key() {
    return 'sa_enquiries_sent';
  }

  get _defaultValue() {
    return [];
  }

  set value(value) {
    if (!Array.isArray(value)) {
      throw new Error('EnquiriesSent data accept only array values');
    }
    this.data = [...new Set([...this.data ,...value])].map((index) => Number(index));
    this._save();
  }
}